// custom-collection.js
document.addEventListener('DOMContentLoaded', () => {
  const filterContainers = document.querySelectorAll('.cc-sort');

  filterContainers.forEach(container => {
    const toggleBtn = container.querySelector('.cc-filter-item');
    if (!toggleBtn) return;

    toggleBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      // Close all other open dropdowns
      filterContainers.forEach(other => {
        if (other !== container) {
          other.classList.remove('active');
        }
      });
      container.classList.toggle('active');
    });
  });

  // Close any open dropdown when clicking outside
  document.addEventListener('click', (e) => {
    filterContainers.forEach(container => {
      if (!container.contains(e.target)) {
        container.classList.remove('active');
      }
    });
  });

  // Handle Sort selection buttons
  const sortButtons = document.querySelectorAll('.cc-sort__dropdown button[data-value]');
  sortButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      const sortValue = btn.getAttribute('data-value');
      if (sortValue) {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('sort_by', sortValue);
        window.location.search = urlParams.toString();
      }
    });
  });
});
